import https from "@/lib/https";
import type {
  EducationDetail,
  EducationPayload,
  GetEducationListParams,
} from "@/interface/profile";
import type { ApiResponse } from "@/interface/common";

const BASE_URL = "/api/educations/";

export const getEducationList = async (
  params?: GetEducationListParams,
): Promise<ApiResponse<EducationDetail[]>> => {
  return await https.get<ApiResponse<EducationDetail[]>>(BASE_URL, params);
};

export const getEducationById = async (
  id: string | number,
): Promise<ApiResponse<EducationDetail>> => {
  return await https.get<ApiResponse<EducationDetail>>(`${BASE_URL}${id}/`);
};

export const createEducation = async (
  payload: EducationPayload,
): Promise<ApiResponse<EducationDetail>> => {
  return await https.post<ApiResponse<EducationDetail>>(BASE_URL, payload);
};

export const updateEducation = async (
  id: string | number,
  payload: EducationPayload,
): Promise<ApiResponse<EducationDetail>> => {
  return await https.put<ApiResponse<EducationDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const patchEducation = async (
  id: string | number,
  payload: Partial<EducationPayload>,
): Promise<ApiResponse<EducationDetail>> => {
  return await https.patch<ApiResponse<EducationDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteEducation = async (
  id: string | number,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
